module.exports = __webpack_public_path__ + "static/media/27 Half Guard.29816b8d.jpg";